import React, { Component } from 'react'
import { MuiTextField, MuiEdit, MuiGrid, MuiIconButton, MuiClear, MuiTypography, MuiSelect, MuiMenuItem, MuiListItemText, MuiFormControl, MuiInputLabel, MuiKeyboardArrowDown, MuiKeyboardArrowUp, MuiPaper, MuiPopover } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import ElectivesListComponent from './ElectivesListComponent';
import { GradePickerComponent, gradePickerUtil } from '../../gradePicker';
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';
import { rulesUtil } from '../rules/dialog'
import AlertDialogComponent from '../teacher/AlertDialogComponent';

export class AddElectivesComponent extends Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
			toggleChange: false,
			electiveSubjectList: [],
			subjectsToBeEnabled: [],
			previouslySavedSubjects: [],
			isElectiveDropDownClicked: false,
			isGradeDropDownClicked: false,
			subjects: props.activeSchool.school_master.subjects,
			showDropDownFlag: false,
			anchorEl: null,
			allGradesFromActiveSchool: { gradeLevels: props.activeSchool.school_master.gradeLevels },
			gradeString: "All Grades",
			showDeleteConfirmDialog: false,
			showGradeDetailChangeConfirmDialog: false,
			showSubjectChangeConfirmDialog: false,
			constraintsArray: [
				"numberOfTeachersAndTAsForElectives",
				"fixedTeachersAndTAsForElectives",
				"multiPeriods",
				"preferredPeriods",
				"sharedRoomsForElectives",
				"totalPeriods",
				"jointClasses"
			],
			validationFlag: true,
			gradeDetails: {}
		}
	};

	handleOpen = () => {
		if (this.props.elective.gradeDetails != undefined && !lodashUtil.isEmpty(this.props.elective.gradeDetails)) {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON(this.props.gradeLevelsToBeRendered, this.props.elective.gradeDetails)
			this.setState({ gradeLevelsToBeRendered: gradeLevels, open: true });
		} else {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSONToBeRendered(this.props.gradeLevelsToBeRendered);
			this.setState({ gradeLevelsToBeRendered: gradeLevels, open: true });
		}
	};

	handleClose = () => {
		this.setState({ isGradeDropDownClicked: false, open: false });
	};

	handleChange = (event) => {
		this.setState({ subjectName: event.target.value })
	};

	//to show the subjects which are applicable to be selected
	dropDownForElective = (event) => {
		const i18n = this.props.i18n
		if (lodashUtil.isEmpty(this.props.elective.gradeDetails)) {
			toast(i18n.electives.clickingSubjectsBeforeGrade);
		} else {
			let value;
			let previouslySavedSubjects = [];
			let electiveSubjectList = this.props.elective.subjects
			this.props.elective.subjects.map((subject) => {
				previouslySavedSubjects.push(subject);
			})
			if (event != undefined) {
				value = event.currentTarget;
			} else {
				value = null;
			}
			this.setState({ previouslySavedSubjects: previouslySavedSubjects, showDropDownFlag: true, anchorEl: value, electiveSubjectList: electiveSubjectList });
			this.addSubjectsToDisplay();
		}


	};

	onClose = () => {
		this.setState({ showDropDownFlag: false })
	}

	addSubjectsToDisplay = () => {
		if (this.props.elective != undefined && !lodashUtil.isEmpty(this.props.elective.gradeDetails)) {
			let gradeDetails = this.props.elective.gradeDetails;
			let subjects = this.props.elective.subjects;
			this.subjectsToBeEnabledForSelectedGrade(gradeDetails);
			this.subjectIsChecked(subjects);
			this.setState({ isElectiveDropDownClicked: !this.state.isElectiveDropDownClicked });
		}
	};

	clearingOfSubjects = () => {
		this.props.elective.subjects = this.state.previouslySavedSubjects;
		this.setState({ isElectiveDropDownClicked: !this.state.isElectiveDropDownClicked });

	};

	// the subejcts which are "ticked" for the grade.
	subjectIsChecked = (subjects) => {
		let allSubjects = this.state.subjects;
		if (subjects === undefined || subjects.length === 0) {
			for (let i = 0; i < allSubjects.length; i++) {
				allSubjects[i].isChecked = false;
			}
		} else {
			for (let i = 0; i < allSubjects.length; i++) {
				let isCheckedFlag = false;
				for (let j = 0; j < subjects.length; j++) {
					if (allSubjects[i].name === subjects[j].name) {
						isCheckedFlag = true;

					}
				}
				if (isCheckedFlag === true) {
					allSubjects[i].isChecked = true;
				} else {
					allSubjects[i].isChecked = false;
				}
			}
		}
		this.setState({ subjects: allSubjects });
	}


	// on click of the subject the whole subject's object will be pushed into an array 
	// and if it is unchecked then it will be (splice) removed 
	onClickOfSubject = (subjectObj, isChecked, event) => {
		let electiveSubjectList = this.props.elective.subjects;
		subjectObj[isChecked] = event.target.checked;
		let isSubjectPresent = false;
		electiveSubjectList.map((subjectName, index) => {
			if (subjectObj.name === subjectName.name) {
				subjectObj.isChecked = false;
				isSubjectPresent = true;
				electiveSubjectList.splice(index, 1)
			}
		})
		if (isSubjectPresent === false) {
			subjectObj.isChecked = true;
			electiveSubjectList.push({
				subjectId: subjectObj._id,
				name: subjectObj.name,
				subjectCode: subjectObj.code,
				color: subjectObj.color
			});
		}
		this.setState({ electiveSubjectList: electiveSubjectList });
	};

	//selected subjects are pushed into an array 
	savingOfElectives = async () => {
		let electivesArray = this.props.activeSchool.school_master.electives
		let scheduleConstraints = this.props.schedule_constraints
		let electivesWithId = this.props.electives.filter(function (elective) {
			return elective._id !== undefined
		})
		if (scheduleConstraints !== undefined && scheduleConstraints.length !== 0 && this.props.elective._id !== undefined) {
			if (this.props.editElectivesInRules(electivesWithId, electivesArray, scheduleConstraints, "isSubjectChangedInElective")) {
				this.setState({
					showSubjectChangeConfirmDialog: true
				})
			}
		}
		else {
			this.savesubjectsInElective()
		}
	};

	savesubjectsInElective = () => {
		const i18n = this.props.i18n
		if (this.state.electiveSubjectList.length < 2) {
			toast(i18n.electives.selectMin2Subejct);
		} else {
			this.props.elective.subjects = this.state.electiveSubjectList;
			this.setState({ toggleChange: !this.state.toggleChange });
			this.dropDownForElective();
		}
		this.props.updateData()
		this.setState({
			showSubjectChangeConfirmDialog: false
		})
	}


	deleteRulesForElective = () => {
		this.props.deleteRulesForElectivesIfGradeChanged(this.state.constraintsArray, this.props.elective)

		this.setState({
			showGradeDetailChangeConfirmDialog: false,
			validationFlag: true
		});
		this.onClickOfSaveInGradePicker(this.state.gradeDetails)
	}

	checkIfGradeDetailsAreChanged = (gradeDetails) => {
		const i18n = this.props.i18n
		let lowestFormOfGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, this.props);
		if (lowestFormOfGradeDetails.length === 0) {
			toast(i18n.electives.minOneGroupToBeSelected)
		} else {
			let elective = this.props.elective
			let scheduleConstraints = this.props.activeSchool.schedule_constraints
			if (this.props.elective._id !== undefined && scheduleConstraints !== undefined && scheduleConstraints.length !== 0) {
				if (rulesUtil.checkIfGradeDetailsAreChanged(this.state.constraintsArray, gradeDetails, this.state.showGradeDetailChangeConfirmDialog, elective, scheduleConstraints, this.props)) {
					this.setState({
						gradeDetails: gradeDetails,
						showGradeDetailChangeConfirmDialog: true,
						// validationFlag: false
					})
				} else {
					this.onClickOfSaveInGradePicker(gradeDetails)
				}
			} else {
				this.onClickOfSaveInGradePicker(gradeDetails)
			}
		}
	}
	//SELECTION OF SUBJECTS TO ENABLE OR DISABLE BASED ON THE GRADES PICKED 
	onClickOfSaveInGradePicker = (gradeDetails) => {
		let isGradeChanged = this.checkIfGradesAreChangedValidation(gradeDetails)
		if (isGradeChanged === true) {
			this.props.updateData()
			this.props.elective.subjects = []
			this.checkIfGradesAreChanged(gradeDetails);
			this.subjectsToBeEnabledForSelectedGrade(gradeDetails);
		} else {
			this.props.elective.gradeDetails = gradeDetails;
			let elective = this.props.elective;
			let electiveSubjectList = [];
			for (let a = 0; a < elective.subjects.length; a++) {
				let subject = this.props.elective.subjects[a];
				electiveSubjectList.push(subject);
			}
			this.setState({
				electiveSubjectList: electiveSubjectList,
				gradeString: gradeString
			})
		}
		let gradeString = gradePickerUtil.getGradesString(gradeDetails)
		this.setState({
			gradeString: gradeString
		})
		this.handleClose();
		// }
	}

	/**
	 * check if the user has changed the subject if no then do not do anything.
	 * if the gradeDetails are changed then check if the subjects which are added 
	 * if they come under selected gradeDetail then do not remove that subject.
	 */
	checkIfGradesAreChangedValidation = (gradeDetails) => {
		let gradeDetailsChanged = true;
		let electiveObj = this.props.elective;
		let subjectList = this.props.activeSchool.school_master.subjects;
		let electiveGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(this.props.elective.gradeDetails, this.props)
		let updatedGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, this.props)
		if (electiveGradeDetails.length === updatedGradeDetails.length) {
			let differenceInGradeDetail = lodashUtil.difference(electiveGradeDetails, updatedGradeDetails)
			if (differenceInGradeDetail.length === 0) {
				gradeDetailsChanged = false
				return gradeDetailsChanged
			}
		}
		if (gradeDetailsChanged === true) {
			this.props.updateData()
			for (let k = 0; k < electiveObj.subjects.length; k++) {
				let subject = electiveObj.subjects[k];
				let subjectObj = lodashUtil.find(subjectList, ["name", subject.name]);
				let subGradeDetails = gradePickerUtil.convertingGradeDetailsToLowestFormat(subjectObj.gradeDetails, this.props);
				let checkGradeDetail = lodashUtil.difference(updatedGradeDetails, subGradeDetails);
				if (checkGradeDetail.length !== 0) {
					electiveObj.subjects.splice(k, 1);
					if (electiveObj.subjects.length < 2) {
						gradeDetailsChanged = true;
						return gradeDetailsChanged;
					}
				}
			}
		}
	}

	// when the user changes the gradeDetails for the second time.
	checkIfGradesAreChanged = (gradeDetails) => {
		let subjects = [];
		let gradeDetailsInElective = this.props.elective.gradeDetails;

		if (gradeDetails.allGrades === gradeDetailsInElective.allGrades) { // "ALL GRADES" check for the grade levels in both the saved object in electvie and gradeDetails passed from the grade picker
			if (gradeDetails.gradeLevels.length === gradeDetailsInElective.gradeLevels.length) { // "GRADE LEVEL" check if both the objects have the same grade Level. checking if the lenght of the two objects are same and then checking the values.
				let checkForGradeLevel = lodashUtil.differenceBy(gradeDetailsInElective.gradeLevels, gradeDetails.gradeLevels, "level");
				if (checkForGradeLevel.length === 0 && (gradeDetails.grades.length === gradeDetailsInElective.grades.length)) { // "GRADES" comparing the two objects just like gradeLevel. (length and value)
					let checkForGrades = lodashUtil.differenceBy(gradeDetailsInElective.grades, gradeDetails.grades, 'grade');
					if (checkForGrades.length === 0) {
						// "GROUPS"
						for (let i = 0; i < gradeDetailsInElective.grades.length; i++) {
							let gradeName = gradeDetailsInElective.grades[i].grade;
							let gradeIndex = lodashUtil.findIndex(gradeDetails.grades, ['grade', gradeName]);
							if (gradeDetailsInElective.grades[i].groups != undefined
								&& gradeDetailsInElective.grades[i].groups.length > 0) { // elective gradeDetails conditions

								// 1) Take the name of the group's grade from the already saved groups (gradeDetailsInElective) 
								// 2) find out at what index this same grade is present in the new saved gradeDetails
								// 3) now compare both the groups (length and value).
								if (gradeDetails.grades[gradeIndex].groups != undefined
									&& gradeDetails.grades[gradeIndex].groups.length > 0
									&& (gradeDetailsInElective.grades[i].groups.length === gradeDetails.grades[gradeIndex].groups.length)) { // picked gradeDetails condition
									let checkForGroups = lodashUtil.differenceBy(gradeDetailsInElective.grades[i].groups, gradeDetails.grades[gradeIndex].groups, 'groupCode');
									if (checkForGroups.length === 0) {
										return;
									} else {
										break;
									}
								} else {
									break;
								}
							} else { // if there is no groups in the elective...  then grades also shouldnt have groups 
								if (gradeDetails.grades[gradeIndex].groups === undefined) {
									// goes back to the next itteration.
									continue;
								} else {
									break;
								}

							}
						}
					}
				}
			}
		}
		// this.props.elective.subjects = [];
		this.subjectIsChecked(subjects);
		this.setState({ toggleChange: !this.state.toggleChange });
	}

	// gives us the subjects which are selectable for the selected grade.
	subjectsToBeEnabledForSelectedGrade = (gradeDetails) => {

		this.props.elective.gradeDetails = gradeDetails;
		let newSubjectArr = [];
		let subjects = this.state.subjects;
		if (gradeDetails != null) {
			// if "ALL GRADES" in grade picker are true then all the subjects are pushed into the array
			if (gradeDetails.allGrades === true) {
				for (let i = 0; i < subjects.length; i++) {
					let subGradeDetails = subjects[i].gradeDetails
					if (subGradeDetails.allGrades === true) {
						newSubjectArr.push(subjects[i]);
					}
				}

			}

			// "GRADE LEVEL" in grade picker if the user has selected any "GRADE LEVEL" then it compares with the subjects grade level.
			else if (gradeDetails.gradeLevels.length > 0) {
				if (gradeDetails.grades.length > 0) {

					this.findingGradeLevelForGrade(gradeDetails, this.state.allGradesFromActiveSchool, subjects, newSubjectArr);
				}

				for (let i = 0; i < subjects.length; i++) {
					if (subjects[i].gradeDetails.allGrades === true) {
						newSubjectArr.push(subjects[i]);
					}
					else if (subjects[i].gradeDetails.gradeLevels != null) {
						let gradeLevelDifference = lodashUtil.differenceBy(gradeDetails.gradeLevels, subjects[i].gradeDetails.gradeLevels, 'level');
						// 'level' in both the objects the 'level's value will be compared and if it matches then it will give an empty array '[]'
						if (gradeLevelDifference.length === 0) {
							if (gradeDetails.grades != undefined) {

								let gradesDifference = lodashUtil.differenceBy(gradeDetails.grades, subjects[i].gradeDetails.grades, 'grade');
								if (gradesDifference.length === 0) {
									newSubjectArr.push(subjects[i]);
								}
							} else {
								newSubjectArr.push(subjects[i]);
							}

						}
					}
				}

			}

			// "GRADES" in grade picker if user has selected "GRADES" then it compares with the subjects which have the same grades and pushes that into a new array
			else if (gradeDetails.grades.length > 0) {
				;
				this.findingGradeLevelForGrade(gradeDetails, this.state.allGradesFromActiveSchool, subjects, newSubjectArr);
				for (let h = 0; h < gradeDetails.grades.length; h++) {
					// " GRADE DETAILS" in GRADEPICKER contains only grades.
					if (gradeDetails.grades[h].groups == undefined) {
						for (let a = 0; a < subjects.length; a++) {
							;
							if (subjects[a].gradeDetails.allGrades === true) { // GRADES are clicked and all the subjects which have allgrades true are pushed to an array
								newSubjectArr.push(subjects[a]);
							} else if (subjects[a].gradeDetails.grades != null) { // GRADES are clicked and the subjects which have the respective grades in it are pushed to an array 
								for (let j = 0; j < subjects[a].gradeDetails.grades.length; j++) {
									;
									if (subjects[a].gradeDetails.grades[j].groups === undefined || subjects[a].gradeDetails.grades[j].groups.length <= 0) {
										//if the groups are not present in the picked grade then it will enter this to compare only the grades with the subjects.
										;
										let gradesDifference = lodashUtil.differenceBy(gradeDetails.grades, subjects[a].gradeDetails.grades, 'grade');
										if (gradesDifference.length === 0) {
											newSubjectArr.push(subjects[a]);
											break;
										}
									}
								}
							}

							//write a method to find out which grade level the selected grade belongs to.

							else if (subjects[a].gradeDetails.grades != null) { // GRADES are clicked and the subjects which have the respective grades in it are pushed to an array 
								for (let j = 0; j < subjects[a].gradeDetails.grades.length; j++) {
									if (subjects[a].gradeDetails.grades[j].groups === undefined || subjects[a].gradeDetails.grades[j].groups.length <= 0) {
										//if the groups are not present in the picked grade then it will enter this to compare only the grades with the subjects.
										let gradesDifference = lodashUtil.differenceBy(gradeDetails.grades, subjects[a].gradeDetails.grades, 'grade');
										if (gradesDifference.length === 0) {
											newSubjectArr.push(subjects[a]);
										}
									}
								}
							}
						}
						// "GROUPS" grade details containe 
					} else if (gradeDetails.grades[h].groups != undefined) {
						for (let i = 0; i < subjects.length; i++) { // "I" loops over "SUBJECTS"
							if (subjects[i].gradeDetails.allGrades === true) {
								newSubjectArr.push(subjects[i]);
							}
							else if (subjects[i].gradeDetails.grades != null) {
								for (let g = 0; g < subjects[i].gradeDetails.grades.length; g++) { // "G" loops over the "SUBJECTS[i].gradeDetails.GRADES"
									let gradesDifference = lodashUtil.differenceBy(gradeDetails.grades, subjects[i].gradeDetails.grades, 'grade');
									if (gradesDifference.length === 0) { // 1) GRADES are matching in both gradeDeatils and in subjects then 
										if (subjects[i].gradeDetails.grades[g].groups.length > 0) { // 2) we check if the GROUPS have any attribute in subjects. If YES then compare groups in both gradeDetails and subjects and push it into an array
											for (let k = 0; k < gradeDetails.grades.length; k++) {  // "K" this loops over the "gradeDetails.GRADE"
												let groupsDifference = lodashUtil.differenceBy(gradeDetails.grades[k].groups, subjects[i].gradeDetails.grades[g].groups, 'groupCode');
												if (groupsDifference.length === 0) {

													newSubjectArr.push(subjects[i]);
												}
											}
										} else { // 3) GRADES are compared and matched but GRADEDETAILS do not have GROUPS in it yet the subject should be pushed because if the subject MATHS is selected for 1 and the user clicks on 1-A MATHS is applicable for 1.
											newSubjectArr.push(subjects[i]);

										}
									}
								}
							}

						}
						// "GROUPS" grade details containe 
					} else if (gradeDetails.grades[h].groups != undefined) {
						for (let i = 0; i < subjects.length; i++) { // "I" loops over "SUBJECTS"
							if (subjects[i].gradeDetails.allGrades === true) {
								newSubjectArr.push(subjects[i]);
							}
							else if (subjects[i].gradeDetails.grades != null) {
								for (let g = 0; g < subjects[i].gradeDetails.grades.length; g++) { // "G" loops over the "SUBJECTS[i].gradeDetails.GRADES"
									let gradesDifference = lodashUtil.differenceBy(gradeDetails.grades, subjects[i].gradeDetails.grades, 'grade');
									if (gradesDifference.length === 0) { // 1) GRADES are matching in both gradeDeatils and in subjects then 
										if (subjects[i].gradeDetails.grades[g].groups.length > 0) { // 2) we check if the GROUPS have any attribute in subjects. If YES then compare groups in both gradeDetails and subjects and push it into an array
											for (let k = 0; k < gradeDetails.grades.length; k++) {  // "K" this loops over the "gradeDetails.GRADE"
												let groupsDifference = lodashUtil.differenceBy(gradeDetails.grades[k].groups, subjects[i].gradeDetails.grades[g].groups, 'groupCode');
												if (groupsDifference.length === 0) {
													newSubjectArr.push(subjects[i]);
												}
											}
										} else { // 3) GRADES are compared and matched but GRADEDETAILS do not have GROUPS in it yet the subject should be pushed because if the subject MATHS is selected for 1 and the user clicks on 1-A MATHS is applicable for 1.
											newSubjectArr.push(subjects[i]);
										}
									}
								}
							}

						}
					}
				}

			}
		}

		newSubjectArr = lodashUtil.uniqBy(newSubjectArr, "code")
		this.setState({ subjectsToBeEnabled: newSubjectArr });

	}
	findingGradeLevelForGrade = (gradeDetails, allGradesFromActiveSchool, subjects, newSubjectArr) => {
		let tempArray = [];
		if (gradeDetails.gradeLevels.length > 0) {
			for (let b = 0; b < gradeDetails.gradeLevels.length; b++) {
				let gradeLevel = gradeDetails.gradeLevels[b].level;
				let gradeLevelName = lodashUtil.find(allGradesFromActiveSchool.gradeLevels, ['levelName', gradeLevel]);
				if (gradeLevelName != undefined) {
					tempArray.push(gradeLevelName);
				}
			}
		}
		for (let i = 0; i < allGradesFromActiveSchool.gradeLevels.length; i++) { // All GRADES FROM ACTIVE SCHOOL
			for (let j = 0; j < gradeDetails.grades.length; j++) { // GRADES from gradeDetials
				let grade = gradeDetails.grades[j].grade;
				let gradeLevelObject = lodashUtil.find(allGradesFromActiveSchool.gradeLevels[i].grades, ['gradeName', grade]);
				if (gradeLevelObject != undefined) {
					tempArray.push(allGradesFromActiveSchool.gradeLevels[i]);
				}
			}
		}
		for (let k = 0; k < subjects.length; k++) { // loop SUBJECTS
			let checkAllGradePresent = true;
			for (let m = 0; m < tempArray.length; m++) { // loop tempArray
				if (subjects[k].gradeDetails.gradeLevels.length > 0) {
					let levelname = tempArray[m].levelName;
					let subject = lodashUtil.find(subjects[k].gradeDetails.gradeLevels, ['level', levelname]);
					if (subject === undefined) {
						checkAllGradePresent = false;
						continue;
					}
				} else {
					checkAllGradePresent = false;
				}
			}
			if (checkAllGradePresent === true) {
				newSubjectArr.push(subjects[k]);
			}
		}
		this.setState({ subjectsToBeEnabled: newSubjectArr });
	}





	// a method to check if in the newSubjectArry a particular subject already exists
	// havent used this method in the code yet. 
	checkIfSubjectExists = (newSubjectArr, subject) => {

		if (newSubjectArr.length === 0) {
			newSubjectArr.push(subject);
		} else {
			let ifSubjectAlreadyExists = lodashUtil.differenceBy(subject, newSubjectArr, "name");
			if (ifSubjectAlreadyExists.length === 0) {
				newSubjectArr.push(subject);
			}
		}
		this.setState({ subjectsToBeEnabled: newSubjectArr });
	}

	// this method compares all the subjects in the school and the subjects which are applicable for the grades picked
	compareSubjectsToEnbaleChecking = (subjectObj) => {

		let subjectsToBeEnabled = this.state.subjectsToBeEnabled;
		let flag = 'disabled';
		if (subjectsToBeEnabled.length === 0) {
			return flag;
		} else { // subjectsToBeEnabled containes some subjects 
			for (let i = 0; i < subjectsToBeEnabled.length; i++) {
				if (subjectObj.name === subjectsToBeEnabled[i].name) {
					flag = ''
					return flag;
				}
			}
			return flag;
		}
	};

	onChange = (name, event) => {
		this.props.elective[name] = event.target.value
		this.props.updateData()
		this.setState({
			toggleChange: !this.state.toggleChange,
		})
	};

	handleDelete = () => {
		let key = this.props.index;
		this.props.removeElectiveFromElectives(key)
		this.props.updateData()
		this.setState({ showDeleteConfirmDialog: false });

	}

	toggleChangeForGradePicker = () => {
		this.setState({ isGradeDropDownClicked: !this.state.isGradeDropDownClicked });
	}
	componentWillMount() {
		let gradeDetails = this.props.elective.gradeDetails
		let gradeString = gradePickerUtil.getGradesString(gradeDetails);
		this.setState({
			open: false,
			gradeString: gradeString
		})
	}

	onClickOfDeleteElective = () => {
		const i18n = this.props.i18n
		this.setState({
			errorMessage: i18n.electives.deletingElective,
			showDeleteConfirmDialog: true
		});
	}

	handleCloseDialog = () => {
		this.setState({
			showDeleteConfirmDialog: false,
			showGradeDetailChangeConfirmDialog: false,
			showSubjectChangeConfirmDialog: false,
		});
	}


	render() {
		const { i18n } = this.props
		return (
			<MuiGrid >

				<MuiGrid container xs={12} >
					{/* 1st box */}
					<MuiGrid item xs={3} style={theme.gridTableSelectStyle}>
						<MuiTextField
							id='name'
							value={this.props.elective.name}

							onChange={(event) => this.onChange('name', event)}
							InputProps={{ native: true, disableUnderline: true }}
							style={{ width: "100%", height: "100%" }}

						/>
					</MuiGrid>

					{/* 2nd box which displays the selected grades */}
					<MuiGrid container xs={4} style={theme.gridTableStyle} >
						<MuiGrid container xs={12} style={theme.pointer} alignContent="center" onClick={() => { this.toggleChangeForGradePicker() }}>


							{/* <MuiGrid container xs={2} > */}
							{this.state.isGradeDropDownClicked === true ?
								<MuiGrid container xs={12} direction='row' onClick={() => this.handleClose()}>
									<MuiGrid item xs={10} justify="center" alignItems="center">
										<MuiTypography>{gradePickerUtil.getGradesString(this.props.elective.gradeDetails)}</MuiTypography>
									</MuiGrid>
									<MuiGrid item xs={2}>
										<MuiKeyboardArrowUp color="primary" />
									</MuiGrid>
								</MuiGrid>
								:
								<MuiGrid container xs={12} direction='row' onClick={() => this.handleOpen()}>
									<MuiGrid item xs={10} justify="center" alignItems="center">
										<MuiTypography>{gradePickerUtil.getGradesString(this.props.elective.gradeDetails)}</MuiTypography>
									</MuiGrid>
									<MuiGrid item xs={2}>
										<MuiKeyboardArrowDown color="primary" />
									</MuiGrid>
								</MuiGrid>
							}
						</MuiGrid>
						{/* </MuiGrid> */}
						{this.state.isGradeDropDownClicked === true &&
							<GradePickerComponent
								gradeLevels={this.props.gradeLevelsToBeRendered}
								{...this.props}
								{...this.state}
								onClickOfSaveInGradePicker={this.checkIfGradeDetailsAreChanged}
								handleClose={this.handleClose}
								handleOpen={this.handleOpen} />
						}
					</MuiGrid>

					{/* 3rd box */}
					{/* drop down to show the applicable subjects for the selected grades */}

					<MuiGrid container xs style={theme.gridTableStyle}>
						<MuiGrid container xs={12} style={theme.pointer} alignContent="center"
							onClick={(event) => this.dropDownForElective(event)} >
							<MuiGrid container xs={10} justify="center" alignContent="center" >

								{/* Showing the checked subjects name  */}

								{this.props.elective.subjects.map((electvie, index) => (
									<MuiGrid item id="grid">
										{index === 0 ?
											<MuiTypography>{electvie.name}</MuiTypography>
											:
											<MuiTypography>{`,${electvie.name}`}</MuiTypography>
										}
									</MuiGrid>
								))}

							</MuiGrid>


							{/* Showing the down arrow and up arrow which shows the subjects applicable  */}
							{this.state.isElectiveDropDownClicked === true ?

								<MuiGrid item xs={2} id="arrowUp" style={theme.pointer}>
									<MuiKeyboardArrowUp color="primary" />
								</MuiGrid>
								:
								<MuiGrid item xs={2} id="arrowDown" style={theme.pointer}>
									<MuiKeyboardArrowDown color="primary" />
								</MuiGrid>
							}
						</MuiGrid>

						<MuiPopover
							open={this.state.isElectiveDropDownClicked}
							//onClose={this.onClose}
							anchorEl={this.state.anchorEl}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "right"
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right"
							}}>
							<MuiGrid container style={{ border: "2px solid " + theme.palette.primary.main, padding: "8px", maxWidth: "40vw", overflowY: "hidden" }}>
								<ElectivesListComponent id="electiveList"
									{...this.props}
									{...this.state}
									compareSubjectsToEnbaleChecking={this.compareSubjectsToEnbaleChecking}
									clearingOfSubjects={this.clearingOfSubjects}
									savingOfElectives={this.savingOfElectives}
									subjects={this.state.subjects}
									onClickOfSubject={this.onClickOfSubject}
									electiveListStyle={this.state.electiveListStyle} />
							</MuiGrid>
						</MuiPopover>
					</MuiGrid>


					< MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
						<MuiIconButton id='delete' onClick={this.onClickOfDeleteElective}>
							<MuiClear style={{ color: theme.palette.grey.dark }} />
						</MuiIconButton>
					</ MuiGrid>

					{this.state.showDeleteConfirmDialog &&
						<AlertDialogComponent
							{...this.props}
							errorMessage={this.state.errorMessage}
							openDialog={this.state.showDeleteConfirmDialog}
							handleCloseDialog={this.handleCloseDialog}
							handleClickOnYes={this.handleDelete}
						/>
					}

					{this.state.showGradeDetailChangeConfirmDialog &&
						<AlertDialogComponent
							{...this.props}
							errorMessage={i18n.electives.relatedInfoDeletingMsg}
							openDialog={this.state.showGradeDetailChangeConfirmDialog}
							handleCloseDialog={this.handleCloseDialog}
							handleClickOnYes={this.deleteRulesForElective}
						/>
					}
					{this.state.showSubjectChangeConfirmDialog &&
						<AlertDialogComponent
							{...this.props}
							errorMessage={i18n.electives.relatedInfoDeletingMsgForSubjectChange}
							openDialog={this.state.showSubjectChangeConfirmDialog}
							handleCloseDialog={this.handleCloseDialog}
							handleClickOnYes={this.savesubjectsInElective}
						/>
					}

				</ MuiGrid>

			</MuiGrid >
		)
	}
}

export default AddElectivesComponent;